import {Provider} from 'mobx-react';
import React from 'react';

import {Assertion, AssertionProps} from '@udemy/badging';
import {useI18n} from '@udemy/i18n';
import {RESOURCE_TYPES} from '@udemy/organization';
import {Dropdown} from '@udemy/react-menu-components';
import {
    ShareToSlackMenuItem,
    ShareToMSTeamsMenuItem,
    ShareToWorkplaceMenuItem,
} from '@udemy/resource-context-menu';
import {UDData, useUDData} from '@udemy/ud-data';

import {isUserAssertionOwner} from '../lib/utils';
import {AddToLinkedInMenuItem} from './add-to-linkedin-menu-item/add-to-linkedin-menu-item.react-component';
import {ShareUrlMenuItem} from './share-url-menu-item/share-url-menu-item.react-component';

const shouldRender = (assertion: Assertion, udData: UDData) => {
    return isUserAssertionOwner(udData.me, assertion);
};

export const AssertionShareMenu = ({assertion}: AssertionProps) => {
    const {gettext} = useI18n();
    const udData = useUDData();
    const me = udData.me;
    const context = 'assertion';
    const resourceContextMenuProps = {
        udStyle: 'ghost',
        size: 'small',
    };
    const resourceContextMenuItemProps = {};

    const userUrl = me.is_authenticated ? me.url : '';
    if (!userUrl) {
        return null;
    }

    if (!shouldRender(assertion, udData)) {
        return null;
    }

    const shareResourceData = {
        url: `${userUrl}certifications/${assertion.id}/`,
        title: assertion.badgeClass.name,
        id: assertion.id,
    };

    return (
        <Provider
            resourceContext={context}
            resourceContextMenuProps={resourceContextMenuProps}
            resourceContextMenuItemProps={resourceContextMenuItemProps}
        >
            <Dropdown
                placement={'bottom-end'}
                trigger={
                    <Dropdown.Button data-purpose="assertion-share-button" size="small">
                        {gettext('Share your success')}
                    </Dropdown.Button>
                }
            >
                <Dropdown.Menu>
                    <ShareToSlackMenuItem
                        resource={assertion}
                        resourceType={RESOURCE_TYPES.BADGE_ASSERTION}
                    />
                    <ShareToMSTeamsMenuItem
                        resource={shareResourceData}
                        resourceType={RESOURCE_TYPES.BADGE_ASSERTION}
                    />
                    <ShareToWorkplaceMenuItem
                        resource={shareResourceData}
                        resourceType={RESOURCE_TYPES.BADGE_ASSERTION}
                    />
                    <ShareUrlMenuItem assertion={assertion} />
                    <AddToLinkedInMenuItem assertion={assertion} />
                </Dropdown.Menu>
            </Dropdown>
        </Provider>
    );
};
